import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MerchantFormService {
  baseUrl = environment.merchantSubmissionBaseUrl;

  constructor(private http: HttpClient) {}

  submitFormData(data: FormData) {
    return this.http.post(`${this.baseUrl}/submit`, data);
  }

  submitSupportRequest(data: {
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    issue: string;
    captchaToken: string;
  }) {
    return this.http.post(`${this.baseUrl}/support`, data);
  }
}
